import type { RadarFilter } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarFilterTypes';

export const mapStops = (stats: RadarFilter | undefined) => {
  if (!stats) {
    return undefined;
  }
  const itineraries = {
    stops: {
      direct: {
        total: {
          min_price: stats.stopPrices.direct.rawPrice || 0,
        },
      },
      one_stop: {
        total: {
          min_price: stats.stopPrices.one.rawPrice || 0,
        },
      },
      two_plus_stops: {
        total: {
          min_price: stats.stopPrices.twoOrMore.rawPrice || 0,
        },
      },
    },
  };
  const filter_hints = {
    enable_direct_filter: stats.stopPrices.direct.isPresent,
    enable_one_stop_filter: stats.stopPrices.one.isPresent,
    enable_two_plus_stops_filter: stats.stopPrices.twoOrMore.isPresent,
  };
  return { itineraries, filter_hints };
};
